var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupDetailsVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21435_2214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.893 12.9H12.9M12.893 12.9C12.4576 13.3319 11.668 13.2248 11.1136 13.2248C10.4332 13.2248 10.1056 13.3578 9.6205 13.8429C9.2075 14.2559 8.6538 15 8 15C7.3462 15 6.7925 14.2559 6.3795 13.8429C5.8937 13.3578 5.5661 13.2248 4.8864 13.2248C4.3327 13.2248 3.5424 13.3326 3.1063 12.9C2.6674 12.4646 2.7752 11.6708 2.7752 11.1136C2.7752 10.4087 2.6212 10.0846 2.1193 9.5834C1.3731 8.8372 1 8.4634 1 8C1 7.5366 1.3731 7.1628 2.12 6.4166C2.568 5.9686 2.7752 5.5248 2.7752 4.8864C2.7752 4.3327 2.6674 3.5424 3.1 3.1063C3.5354 2.6674 4.3292 2.7752 4.8864 2.7752C5.5248 2.7752 5.9686 2.5673 6.4166 2.1193C7.1628 1.3731 7.5366 1 8 1C8.4634 1 8.8372 1.3731 9.5834 2.12C10.0314 2.568 10.4752 2.7752 11.1136 2.7752C11.6673 2.7752 12.4576 2.6674 12.8937 3.1C13.3326 3.5354 13.2248 4.3292 13.2248 4.8864C13.2248 5.5913 13.3788 5.9154 13.8807 6.4166C14.6269 7.1628 15 7.5366 15 8C15 8.4634 14.6269 8.8372 13.88 9.5834C13.3788 10.0853 13.2248 10.4094 13.2248 11.1136C13.2248 11.6708 13.3319 12.4646 12.893 12.9Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90039 8.6251L7.16039 9.75L10.1004 6.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21435_2214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDetailsVerified);
export default __webpack_public_path__ + "static/media/group_details_verified.64dbdfc29062c279d7b047421e47ebbe.svg";
export { ForwardRef as ReactComponent };